import { CircularProgress } from "@mui/material";
export const CircularSpinner = ({ size = "1.5rem", spinnerColor = "#f46c3c" }) => {
  return (
    <CircularProgress
      size={size}
      thickness={4}
      style={{ color: spinnerColor, animationDuration: "1s" }}
    />
  );
};
